import { useProductPageContext } from "shared/product/ProductPageContext/useProductPageContext";
import { ProductSectionData } from "shared/product/ProductSection/product-section.helper";
import { useI18n } from "utils/with-i18n.utils";

import { RatingsMark } from "./RatingsMark";
import { RatingsReview } from "./RatingsReview";

type RatingsSectionProps = {
  productData: ProductSectionData;
};

export const RatingsSection = ({ productData }: RatingsSectionProps) => {
  const i18n = useI18n();
  const { currentVariant } = useProductPageContext();

  if (!productData.productDetail) {
    return null;
  }

  return (
    <>
      {productData.productDetail && productData.productDetail.review && (
        <section className="px-[18px] pt-[60px] mx-auto max-w-1440 lg:px-40 lg:pt-[96px]">
          <h2 className="mb-[60px] text-3xl font-medium text-center lg:text-6xl">
            {i18n.t("product.seo.ratings.title", {
              modelName: productData.family.modelName,
            })}
          </h2>
          <RatingsMark
            rating={productData.productDetail.review.rating}
            image={currentVariant?.combinedPicture ?? undefined}
            source={productData.productDetail.review.source}
          />
          <div className="flex flex-col gap-6 pt-8">
            {productData.productDetail.review.items.map((review) => {
              return (
                <RatingsReview
                  title={review.title}
                  description={review.text}
                  icon={review.icon}
                  key={review.title}
                />
              );
            })}
          </div>
        </section>
      )}
    </>
  );
};
